import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UIRouterModule } from '@uirouter/angular';
import { AccountSharedModule } from 'apps/account/src/account-shared';
import { ClickOutsideModule } from 'ng-click-outside';
import { OrderModule } from 'ngx-order-pipe';
import { CommonDeclarationsModule } from '../../modules/common-declarations/common-declarations.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { AppMenuEntryComponent } from './components/app-menu-entry/app-menu-entry.component';
import { AppMenuComponent } from './components/app-menu/app-menu.component';
import { AppMenuEffects } from './store/app-menu.effects';
import { appMenuReducer } from './store/app-menu.reducer';
import { SpacesModule } from 'account-hybrid/common/components/spaces/spaces.module';
import { MatIconModule } from '@angular/material/icon';
import { PermissionsModule } from 'account-hybrid/common/components/permissions/permissions.module';

@NgModule({
    declarations: [AppMenuComponent, AppMenuEntryComponent],
  imports: [
    CommonModule,
    AccountSharedModule,
    ClickOutsideModule,
    NotificationsModule,
    CommonDeclarationsModule,
    UIRouterModule.forChild({}),
    StoreModule.forFeature('AppMenu', appMenuReducer),
    EffectsModule.forFeature([AppMenuEffects]),
    OrderModule,
    SpacesModule,
    MatIconModule,
    PermissionsModule
  ],
    exports: [AppMenuComponent, AppMenuEntryComponent],
})
export class AppMenuModule {
    constructor() {}
}


